// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1AflT","content":"Consent_content__1GzlK","footer":"Consent_footer__2YF1i"};